import { render } from "./MangelItemTemplate.vue?vue&type=template&id=0a069534&ts=true"
import script from "./MangelItemTemplate.vue?vue&type=script&lang=ts"
export * from "./MangelItemTemplate.vue?vue&type=script&lang=ts"

import "./MangelItemTemplate.vue?vue&type=style&index=0&id=0a069534&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__